/* eslint-disable import/no-extraneous-dependencies */
import { string } from 'prop-types';
import * as React from 'react';

const ProgressBar = ({ width, background }) => (
  <div
    style={{
      position: 'relative',
    }}
  >
    <div
      className="inner-bar"
      style={{
        // width: '139px',
        height: '8px',
        background: '#f1f5f9',
        borderRadius: '9999px',
      }}
    />
    <span
      style={{
        width,
        background,
        height: '8px',
        position: 'absolute',
        left: '0px',
        bottom: '0px',
        borderRadius: '9999px',
        transition: 'width 0.5s ease-out',
      }}
    />
  </div>
);

ProgressBar.defaultProps = {
  width: '1%',
  background: '#eee',
};

ProgressBar.propTypes = {
  width: string,
  background: string,
};

export default ProgressBar;
